import React, { useEffect, useState } from 'react';
import { Container, Btn } from './index.style';

type list = {};

interface IProps {
  list: list[];
  onClick: (listName: any) => void;
  activeItem?: list;
}

const ButtonSubline: React.FC<IProps> = props => {
  const [active, setActive] = useState(
    props.activeItem ?? props.list[0]
  );

  useEffect(() => {
    if (props.activeItem === undefined || props.activeItem === active) return;
    setActive(props.activeItem);
  }, [props.activeItem, active]);

  return (
    <Container>
      {props.list.map(id => {
        return (
          <Btn
            active={active === id}
            onClick={() => {
              if (active === id) return;
              props.onClick(id);
              setActive(id);
            }}
          >
            {id}
          </Btn>
        );
      })}
    </Container>
  );
};

export default ButtonSubline;
